module.exports = __webpack_public_path__ + "static/media/IMG_5489.33c13199.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_5489.PNG
// module id = 552
// module chunks = 0